import { useMutation } from 'react-query';
import { createBettieMessage, type CreateMessageBody, type CreateMessageResponse } from '../../../bettie/services/bettieService';

export function useCreateBettieMessage() {
  return useMutation<CreateMessageResponse, Error, CreateMessageBody>((body) =>
    createBettieMessage(body)
  );
}

